import { combineReducers } from "redux";
import { StoreStateUi } from "../types/loginTypes";
import reducers from './loginReducers';

export default combineReducers<StoreStateUi>({
    login: reducers
});
